import { render, staticRenderFns } from "./UjianMapelType.vue?vue&type=template&id=55aca814&scoped=true"
import script from "./UjianMapelType.vue?vue&type=script&lang=js"
export * from "./UjianMapelType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aca814",
  null
  
)

export default component.exports